((BoughtTogether, $) => {
  'use strict';

  const $dom = {};

  const cacheDom = () => {
    $dom.addToCart = $('.js-related-add');
    $dom.checkboxes = $('.js-related-product-checkbox');
    $dom.variantSelect = $('.js-related-product-variant');
  };

  const getContainer = ($child) => {
     return $child.closest('.js-related-products');
  };

  const getProducts = ($container) => {
    return $container.find('.js-related-product');
  };

  const getSelectedProducts = ($products) => {
    return $products.filter((index, product) => {
      return $(product).find('.js-related-product-checkbox').is(':checked');
    });
  };

  const addToCart = (event) => {
    const $self = $(event.currentTarget);
    const $container = getContainer($self);
    const $products = getProducts($container);
    const $selectedProducts = getSelectedProducts($products); 
    const $productFreeSamplesGroups = $('.js-product-freesamples-option-group');

    const variants = [];
    let errors = false;
    $selectedProducts.each((index, product) => {
      const $product = $(product);
      const $variant = $product.find('.js-related-product-variant');
      const $productContainer = $product.find('.pdp__related-product-title')
      const productTitle = $productContainer.text();
      const variantId = parseInt($variant.val());

      if (variantId === 0) {
        errors = true;
        const $select = $product.find('.js-related-select');
        $select.addClass('error');
        return;
      }

      variants.push({
        variantId: variantId,
        product: productTitle,
      });
    });

    if (errors) {
      return;
    }

    let count = 0;
    variants.forEach((variant) => {
      const properties = {};

      if ($productFreeSamplesGroups.length > 0) {
        properties['_has_free_samples'] = true;
      }
      CartJS.addItem(variant.variantId, 1, properties, {
        "success": () => {
          count++;
          if (count === variants.length) {
            InlineCart.toggle('show');
          }

          window.setTimeout(function () {
            InlineCart.discountGWP(0);
          }, 3000);
        }
      });

      let variantLineItemInCart = CartJS.cart.items.find((item) => { return item.id == variant.variantId; });
      let productQuantityInCart = typeof variantLineItemInCart !== 'undefined' ? variantLineItemInCart.quantity : 0;

      $productFreeSamplesGroups.each((productFreeSampleIndex, productFreeSampleGroup) => {
        const $productFreeSampleGroup = $(productFreeSampleGroup);
        const productFreeSampleVariantId = $productFreeSampleGroup.attr('data-variant');
        const productFreeSampleProperties = {
          '_free_sample_for_variant_id': variant.variantId,
          '_free_sample_for_product': variant.product,
        };
        let propertiesQuantity,
            propertiesIndex,
            lineItemProperties;
        const propertiesChosen = {
          '_chosen_by_customer': 'Yes'
        };
  
        if (productFreeSampleVariantId) {
          propertiesQuantity = {
            '_free_sample_for_quantity': productQuantityInCart + 1
          };
          propertiesIndex = {
            '_free_sample_index': productFreeSampleIndex + 1
          };
          lineItemProperties = { ...productFreeSampleProperties, ...propertiesQuantity, ...propertiesIndex, ...propertiesChosen };
          CartJS.addItem(productFreeSampleVariantId, 1, lineItemProperties, {
            "success": () => {
              window.setTimeout(function () {
                InlineCart.discountGWP(0);
              }, 3000);
            }
          });
        }
      });
    });
  };

  const updatePrice = (event) => {
    let price = 0;
    let compare = 0;
    const $self = $(event.currentTarget);
    const $container = getContainer($self);
    const $products = getProducts($container);
    const $selectedProducts = getSelectedProducts($products); 

    $selectedProducts.each((index, product) => {
      const $product = $(product);
      const $price = $product.find('.js-related-price');
      const $compare = $product.find('.js-related-compare-price');

      if ($price.length) {
        price += $price.data('price');
      }

      if ($compare.length) {
        compare += $compare.data('price');
      }
    });

    const $totalPrice = $container.find('.js-related-price-total');
    const $totalComparePrice = $container.find('.js-related-compare-price-total');

    $totalPrice.attr('data-price', price).html(Shopify.formatMoney(price));
    $totalComparePrice.attr('data-price', compare);
    
    if (compare > price) {
      $totalComparePrice.html(Shopify.formatMoney(compare));
    } else {
      $totalComparePrice.html('');
    }
    
    $totalPrice.trigger('products-bought-together:changed');

  };

  const clearError = (event) => {
    const $self = $(event.currentTarget);
    const $parent = $self.closest('.js-related-select');
    $parent.removeClass('error');
  }

  const bindUIActions = () => {
    $dom.addToCart.on('click', addToCart); 
    $dom.checkboxes.on('change', updatePrice);
    $dom.variantSelect.on('change', clearError);
  };

  const init = () => {
    cacheDom();
    bindUIActions();
  };

  BoughtTogether.init = init;

})(bvaccel.BoughtTogether = bvaccel.BoughtTogether || {}, jQuery);
